import React, { Fragment } from 'react';
import * as Opt from '../editor/Helpers';

class Footer extends React.Component {
    constructor(props) {
      super();
      this.state = {
        prevTheme: props.theme,
        textColor: props.theme == 'neutral-charcoal' ? 'neutral-cloud' : 'neutral-charcoal',
        svgColor: props.theme == 'neutral-charcoal' ? 'primary-core-filter' : '',
        socialMediaColor: props.theme == 'neutral-charcoal' ? 'neutral-cloud-filter' : '',
        linkStyle: props.theme == 'neutral-charcoal' ? 'neutral-cloud hover-primary-core' : '',

      }
    }

    loadSocialMedia() {
        return(
            <Fragment>
                <a href="https://www.facebook.com/Treebula/" className="mr-[20px]" target="_blank">
                    <img src={`${Window.static_path}img/social-media/FacebookNew.svg`} className={`max-h-[50px] ${this.state.socialMediaColor}`} />
                </a>
                <a href="https://www.instagram.com/treebula.se/" className="mr-[20px]" target="_blank">
                    <img src={`${Window.static_path}img/social-media/InstagramNew.svg`} className={`max-h-[50px] ${this.state.socialMediaColor}`} />
                </a>
                <a href="https://se.linkedin.com/company/treebula" className="mr-[20px]" target="_blank">
                    <img src={`${Window.static_path}img/social-media/LinkedIn.svg`} className={`max-h-[50px] ${this.state.socialMediaColor}`} />
                </a>
                <a href="https://www.youtube.com/@treebula1721/featured" className="mr-[20px]" target="_blank">
                    <img src={`${Window.static_path}img/social-media/Youtube.svg`} className={`max-h-[50px] ${this.state.socialMediaColor}`} />
                </a>
            </Fragment>
        )
    }

    componentDidUpdate() {
        if (this.state.prevTheme != this.props.theme) {
            this.setState({
                prevTheme: this.props.theme,
                textColor: this.props.theme == 'neutral-charcoal' ? 'neutral-cloud' : 'neutral-charcoal',
                svgColor: this.props.theme == 'neutral-charcoal' ? 'primary-core-filter' : '',
                socialMediaColor: this.props.theme == 'neutral-charcoal' ? 'neutral-cloud-filter' : '',
                linkStyle: this.props.theme == 'neutral-charcoal' ? 'neutral-cloud hover-primary-core' : '',
            })
        }
    }

    render() {
        return (
            <div className={`bg-${this.props.theme} ${this.state.textColor} p-0`}>
                <div className='container'>
                    <div className="flex flex-wrap p-[10px] pt-[40px]">
                        <div className="w-full lg:w-1/2 mb-[20px]">
                            <a className="py-[10px]" href="/">
                                <img src={`${Window.static_path}img/icons/treebula_black_filter.svg`} className={`py-2 ${this.state.svgColor}`} style={{width: "190px"}}/>
                            </a>
                            <div onClick={() => {window.scrollTo({ top: 0, behavior: 'smooth' })}} role="button" className={`lg:hidden bg-${this.props.theme == 'neutral-charcoal' ? 'primary-core' : 'neutral-pebble'} rounded-full float-end mr-[40px] mt-[20px]`}>
                                <img src={`${Window.static_path}img/icons/long-arrow-up.svg`} className={`max-h-[50px] ${this.props.theme == 'neutral-charcoal' ? 'neutral-charcoal' : this.props.theme}-filter`} />
                            </div>
                            <p className="fs-7 mt-[20px] mb-[5px]">Adress:</p>

                            <div className="fs-7">
                            <span className="">Stadsgården 6, 116 45 Stockholm</span><br />
                            </div>  
                            <p className="fs-7 mt-[20px] mb-[5px]">Kontakt:</p>
                                <div>
                                <a href="tel:00468339944" className={`fs-7 ${this.state.linkStyle}`}><u>08-33 99 44</u></a>
                                </div>
                                <div>
                                <a href="mailto:information@treebula.se" className={`fs-7 mb-[10px] ${this.state.linkStyle}`}>information@treebula.se</a><br />
                            </div>  
                            <div className="flex w-full flex-wrap py-[10px]">
                            {this.loadSocialMedia()}
                            </div>                         
                        </div>

                        <div className="w-full lg:w-1/6 mb-[20px]">
                            <p className="fs-7 font-bold my-[20px]">Treebula</p>

                            <ul className={`list-none fs-7`}>
                                <li className="mb-2"><a href="/om-oss/" className={`${this.state.linkStyle}`}>Om oss</a></li>
                                <li className="mb-2"><a href="/min-skog/?view=overblick" className={`${this.state.linkStyle}`}>Vad är skogen värd?</a></li>
                                <li className="mb-2"><a href="/referenser/" className={`${this.state.linkStyle}`}>Våra nöjda kunder</a></li>
                                <li className="mb-2"><a href="/om-oss/kontakt/" className={`${this.state.linkStyle}`}>Kontakta oss</a></li>
                            </ul>
                        </div>    
                        <div className="w-full lg:w-1/6">
                            <p className="fs-7 font-bold my-[20px]">Våra Tjänster</p>

                            <ul className="list-none fs-7">
                                <li className="mb-2"><a href="/skogsbruksplan/" className={`${this.state.linkStyle}`}>Generera skogsbruksplan</a></li>
                                <li className="mb-2"><a href="/skogsbruksplan/karta/" className={`${this.state.linkStyle}`}>Din fastighetskarta</a></li>
                                <li className="mb-2"><a href="/skogsbruksplan/overblick/" className={`${this.state.linkStyle}`}>Din fastighetsöverblick</a></li>
                                <li className="mb-2"><a href="/salj-virke/" className={`${this.state.linkStyle}`}>Sälj virke</a></li>
                                <li className="mb-2"><a href="/biobransle/" className={`${this.state.linkStyle}`}>Sälj biobränsle</a></li>
                                <li className="mb-2"><a href="/min-skog/?view=virkespriser" className={`${this.state.linkStyle}`}>Jämför virkespriser</a></li>
                                <li className="mb-2"><a href="/virkespriskollen/" className={`${this.state.linkStyle}`}>Virkespriskollen</a></li>
                            </ul>
                        </div>

                        <div className="w-full lg:w-1/6">
                            <p className="fs-7 font-bold my-[20px]"><a href="/kunskapscentrum/" className={`${this.state.linkStyle}`}>Kunskapscentrum</a></p>
                            <ul className="list-none fs-7">
                                <li className="mb-[10px]"><a href="/kunskapscentrum/artiklar/" className={`${this.state.linkStyle}`}>Artiklar</a></li>
                            </ul>
                        </div>

                        
                        <div className="flex w-full flex-wrap justify-between flex-col-reverse lg:flex-row fs-7 pb-[20px] my-[20px] gap-[15px]">
                            <div className="fs-7 text-nowrap">Copyright © {new Date().getFullYear()} Treebula</div>
                            <div className="flex justify-start flex-col gap-[15px] lg:justify-end lg:flex-row">
                                <div className="fs-8 text-nowrap">
                                    <a href="/privacy/" className={`fs-7 ${this.state.linkStyle}`}>Integritetspolicy</a>
                                </div>
                                <div className="fs-8 text-nowrap">                     
                                    <a href="/terms/" className={`fs-7 ${this.state.linkStyle}`}>Användarvillkor</a> 
                                </div>
                                <div className="fs-8 text-nowrap">                     
                                    <a href="/cookiepolicy/" className={`fs-7 ${this.state.linkStyle}`}>Cookiepolicy</a> 
                                </div>
                            </div>
                        </div>
                    </div>
                        
                    
                </div>
            </div>
        )
    }
}

Footer.defaultProps = {
    theme: 'neutral-charcoal',
}
  
Footer.fields = {
    theme: {
        type: "select",
        options: Opt.themes,
    }
}

export default Footer;